import en from 'date-fns/locale/en-US'
import id from 'date-fns/locale/id'
import { LanguageConst } from "utils/Language"

export const LocalStorageConst = {
    language: 'lang',
    jwtToken: 'jwtToken',
    dateLocale: 'dateLocale',
    loginCheckToken: 'luna@loginCheck',
    pdfViewer: 'luna-pdf@media-',
}

const LocalStorageUtils = {
    language: {
        get: () => localStorage.getItem(LocalStorageConst.language) || LanguageConst.ID,
        set: (languageConst) => localStorage.setItem(LocalStorageConst.language, languageConst),
        clear: () => localStorage.removeItem(LocalStorageConst.language)
    },
    dateLocale: {
        get: () => {
            const dateLocale = localStorage.getItem(LocalStorageConst.language)
            if(dateLocale === LanguageConst.EN) return en
            if(dateLocale === LanguageConst.ID) return id
            return en
        }
    },
    jwtToken: {
        get: () => localStorage.getItem(LocalStorageConst.jwtToken) || '',
        set: (token) => localStorage.setItem(LocalStorageConst.jwtToken, token),
        clear: () => localStorage.removeItem(LocalStorageConst.jwtToken)
    },

    all: {
        clear: () => localStorage.clear()
    },
    loginCheckToken: {
        get: () => localStorage.getItem(LocalStorageConst.loginCheckToken) || '',
        set: () => localStorage.setItem(LocalStorageConst.loginCheckToken, 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'),
        clear: () => localStorage.removeItem(LocalStorageConst.loginCheckToken)
    },
    pdfViewer: {
        get: (id) => localStorage.getItem( LocalStorageConst.pdfViewer+id.toString() ) || 1,
        set: (id, data) => localStorage.setItem( LocalStorageConst.pdfViewer+id.toString(), data),
        clear: () => localStorage.removeItem( LocalStorageConst.pdfViewer+id.toString() )
    },
}

export default LocalStorageUtils
